import { useTranslation } from 'react-i18next';

import Icon from '@appchoose/icon';

type FinancialAdjustmentBadgeProps = {
  type: 'SupplierBillingAdjustmentDraft' | 'SupplierBillingAdjustmentValidated';
};

export const FinancialAdjustmentBadge: React.FC<
  FinancialAdjustmentBadgeProps
> = ({ type }) => {
  const { t } = useTranslation();

  if (type === 'SupplierBillingAdjustmentDraft') {
    return (
      <div className="flex shrink-0 cursor-pointer items-center space-x-1 rounded-sm bg-orange-300 px-2 py-1 text-xs font-semibold text-orange-600">
        <Icon icon="information" className="h-3.5 w-3.5" />
        <span>
          {t('invoice.invoice_information.status.pending_validation')}
        </span>
      </div>
    );
  } else {
    return (
      <div className="flex shrink-0 cursor-pointer items-center space-x-1 rounded-sm bg-[#ECF7F1] px-2 py-1 text-xs font-semibold text-green-600">
        <Icon icon="information" className="h-3.5 w-3.5" />
        <span>{t('invoice.invoice_information.status.validated')}</span>
      </div>
    );
  }
};
